exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget-table .no-feedback[data-v-071243e4] {\n  opacity: .5;\n}\n.expanded[data-v-071243e4] {\n  cursor: pointer;\n}\n.expanded.clicked .expanded__icon[data-v-071243e4] {\n  transform: rotate(-180deg);\n  transition: transform .6s ease-in-out;\n}\n.expanded .expanded__icon[data-v-071243e4] {\n  transition: transform .6s ease-in-out;\n}\n.body__text__footer[data-v-071243e4] {\n  display: none;\n}\n.body__text__footer.expanded__body[data-v-071243e4] {\n  display: block;\n}\n", ""]);

// exports
